import { useApi } from './use-api-call';


export const useSearchSmsStatusApi = () => useApi<{ 
smsStatuses: SmsStatusDTO[];
        allowEdit: boolean; 
    }>('/sms-status/search-sms-status');

export const useGetSmsStatusApi = () => useApi<{ smsStatus: SmsStatusDTO; allowEdit: boolean; }>('/sms-status/get-sms-status/{id}');

export const useSaveSmsStatusApi = () => useApi<{ smsStatus: SmsStatusDTO}>('/sms-status/save-sms-status');

export const useDeleteSmsStatusApi = () => useApi('/sms-status/delete-sms-status/{id}');

export interface SmsStatusDTO { 
id:string;
title:string;
}
